import { format, isToday, isYesterday, isSameDay, isValid } from "date-fns";
import { ptBR } from "date-fns/locale";

/** Evita crash do date-fns `format()` com timestamps inválidos no chat. */
export function parseChatDate(dateStr: string | null | undefined): Date | null {
  if (!dateStr) return null;
  const date = new Date(dateStr);
  return isValid(date) ? date : null;
}

export function formatChatMessageTime(dateStr: string): string {
  const date = parseChatDate(dateStr);
  if (!date) return "";
  if (isToday(date)) return format(date, "HH:mm", { locale: ptBR });
  return format(date, "dd/MM/yy HH:mm", { locale: ptBR });
}

export function formatChatDateSeparator(dateStr: string): string {
  const date = parseChatDate(dateStr);
  if (!date) return "";
  if (isToday(date)) return "HOJE";
  if (isYesterday(date)) return "ONTEM";
  return format(date, "d 'de' MMMM 'de' yyyy", { locale: ptBR }).toUpperCase();
}

export function formatChatActivityLogTime(dateStr: string | null | undefined): string {
  const date = parseChatDate(dateStr);
  if (!date) return "";
  return format(date, "dd/MM/yyyy 'às' HH:mm", { locale: ptBR });
}

export function shouldShowChatDateSeparator(
  index: number,
  currentCreatedAt: string | null | undefined,
  previousCreatedAt: string | null | undefined,
): boolean {
  const current = parseChatDate(currentCreatedAt);
  if (!current) return false;
  if (index === 0) return true;
  const previous = parseChatDate(previousCreatedAt);
  if (!previous) return false;
  return !isSameDay(current, previous);
}
